import type { CreateClientConfig } from '@hey-api/client-axios'

function serializeParams(params: unknown): string {
  const searchParams = new URLSearchParams()

  if (params && typeof params === 'object') {
    Object.entries(params as Record<string, unknown>).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== undefined && item !== null) {
            searchParams.append(key, String(item))
          }
        })
      } else if (value !== undefined && value !== null) {
        searchParams.append(key, String(value))
      }
    })
  }

  return searchParams.toString()
}

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseURL: 'https://example.com',
  paramsSerializer: (params) => serializeParams(params)
})
